module.exports = __webpack_public_path__ + "static/media/googleplay.9dd2f911.svg";